<template>
  <div class="teacher-center-container apple-style">
    
    <div class="ambient-background">
      <div class="orb orb-1"></div>
      <div class="orb orb-2"></div>
      <div class="orb orb-3"></div>
      <div class="noise-overlay"></div>
    </div>

    <transition name="fade-slide" appear>
      <div class="main-content">
        
        <div class="profile-card glass-surface">
          <div class="card-body">
            <div class="avatar-wrap">
              <van-icon name="manager" class="avatar-icon" />
            </div>
            <div class="info-wrap">
              <div class="name">{{ teacherName || '教师用户' }}</div>
              <div class="phone">{{ phoneNumber || '未知手机号' }}</div>
              <div class="school-tag">
                <van-icon name="location-o" />
                <span>{{ currentSchoolName || '暂无学校' }}</span>
              </div>
            </div>
          </div>
          
          <button class="switch-pill-btn" @click="openSchoolPicker" v-if="schoolByTeacherList.length > 1">
            <van-icon name="exchange" />
            <span>切换身份</span>
          </button>
        </div>

        <div class="menu-section glass-surface">
          <van-cell-group :border="false" class="transparent-group">
            <!-- <van-cell 
              title="切换所在学校/身份" 
              icon="exchange" 
              is-link 
              @click="openSchoolPicker" 
              class="apple-cell"
            /> -->
            <van-cell 
              title="修改当前账号密码" 
              icon="lock" 
              is-link 
              @click="showPwdPopup = true" 
              class="apple-cell"
            />
            <van-cell 
              title="注销/解绑当前账号" 
              icon="close" 
              is-link 
              @click="handleUnbind" 
              class="apple-cell danger-cell"
            />
          </van-cell-group>
        </div>
        
        <div class="security-tip">
          <van-icon name="shield-o" />
          <span>您的信息已受到加密保护</span>
        </div>

      </div>
    </transition>

    <van-popup v-model="showPwdPopup" round position="bottom" class="apple-popup glass-popup">
   
      <van-form @submit="onSubmitPassword" class="pwd-form" :show-error-message="false" @failed="onFailed">
        <div class="ios-list-group">
          <van-field
            v-model="pwdForm.password"
            type="password"
            name="password"
            label="新密码"
            placeholder="最少6位字符"
            clearable
            class="ios-field"
            :rules="[
              { required: true, message: '请填写新密码' },
              { validator: validatePwdLength, message: '密码长度不能少于6位' }
            ]"
          />
          <van-field
            v-model="pwdForm.confirmPassword"
            type="password"
            name="confirmPassword"
            label="确认密码"
            placeholder="再次输入以确认"
            clearable
            class="ios-field"
            :rules="[
              { required: true, message: '请确认新密码' },
              { validator: validatePwdConfirm, message: '两次输入的密码不一致' }
            ]"
          />
        </div>
        
        <div class="submit-btn-wrap">
          <van-button round block type="info" native-type="submit" :loading="loading" class="apple-btn-primary">
            确认修改
          </van-button>
        </div>
      </van-form>
    </van-popup>

    <van-popup v-model="showSchoolPicker" round position="bottom" class="apple-popup glass-popup picker-popup">
      <van-picker
        show-toolbar
        title="切换身份/学校"
        :default-index="defaultPickerIndex"
        :columns="schoolByTeacherList"
        value-key="schoolName"
        class="apple-picker"
        @cancel="showSchoolPicker = false"
        @confirm="onConfirmSchool"
      />
    </van-popup>
  </div>
</template>

<script>
import { Notify, Dialog, Toast } from 'vant';
// 确保接口路径与您的项目一致
import { updateTeacherPassword, unbindTeacherAccount, getOneSchoolByTeacherOpenId } from '@/api/teacher/infoCenterTeacher.js';
import { loginByOpenId } from '@/api/bind';
import { getLocal, setLocal, removeLocal } from '@/utils/cookie';

export default {
  name: 'TeacherCenter',
  data() {
    return {
      // 身份信息
      teacherName: '',
      currentSchoolName: '',
      currentSchoolCode: '',
      phoneNumber: '',
      
      // 学校切换相关
      schoolByTeacherList: [], // 绑定的所有学校/身份列表
      showSchoolPicker: false, 
      defaultPickerIndex: 0,
      
      // 密码修改相关状态
      showPwdPopup: false,
      loading: false,
      pwdForm: {
        password: '',
        confirmPassword: ''
      }
    };
  },
  created() {
    this.initUserInfo();
    this.fetchSchoolList();
  },
  methods: {
    // ================= 1. 初始化与账号切换逻辑 =================

    // 1.1 初始化获取当前显示的本地缓存信息
    initUserInfo() {
      // 提取手机号 (兼容不同字段名)
      const userInfoStr = getLocal('userInfo');
      if (userInfoStr) {
        try {
          const userInfo = JSON.parse(userInfoStr);
          this.phoneNumber = userInfo.mobile || userInfo.phoneNumber || '';
        } catch (e) {
          console.error('解析 userInfo 失败', e);
        }
      }

      // 获取当前选中的学校信息
      const teacherTitleInfoStr = sessionStorage.getItem('teacherTitleInfo');
      if (teacherTitleInfoStr) {
        try {
          const schoolInfo = JSON.parse(teacherTitleInfoStr);
          this.currentSchoolName = schoolInfo.schoolName;
          this.currentSchoolCode = schoolInfo.schoolCode;
          this.teacherName = schoolInfo.teacherName;
          
          // 如果用户信息里没手机号，也可以从学校列表数据里拿
          if (!this.phoneNumber && schoolInfo.phoneNumber) {
            this.phoneNumber = schoolInfo.phoneNumber;
          }
        } catch (e) {
          console.error('解析 teacherTitleInfo 失败', e);
        }
      }
    },

    // 1.2 获取该 openId 绑定的所有学校
    fetchSchoolList() {
      const openId = getLocal('openId');
      if (!openId) return;
      
      getOneSchoolByTeacherOpenId({ openId }).then(res => {
        if (res.data && res.data.data && res.data.data.length > 0) {
          this.schoolByTeacherList = res.data.data;
        }
      }).catch(err => {
        console.error('获取学校列表失败', err);
      });
    },

    // 1.3 打开选择器
    openSchoolPicker() {
      if (this.schoolByTeacherList.length > 0) {
        // 定位当前学校的索引
        const currentIndex = this.schoolByTeacherList.findIndex(
          school => school.schoolCode === this.currentSchoolCode
        );
        this.defaultPickerIndex = currentIndex >= 0 ? currentIndex : 0;
        this.showSchoolPicker = true;
      } else {
        Toast('暂无可选的学校信息');
      }
    },

    // 1.4 确认切换学校
    async onConfirmSchool(selectedSchool) {
      // 1. 更新视图数据
      this.currentSchoolName = selectedSchool.schoolName;
      this.currentSchoolCode = selectedSchool.schoolCode;
      this.teacherName = selectedSchool.teacherName;
      this.phoneNumber = selectedSchool.phoneNumber; // 从新身份中提取手机号

      // 2. 存入 session，保持全局一致
      sessionStorage.setItem('teacherTitleInfo', JSON.stringify(selectedSchool));
      
      // 3. 关闭弹窗并开启 Loading
      this.showSchoolPicker = false;
      // 优化：Vant 的默认 Toast 背景太重，这里可以不用填文字，仅显示 Loading 保持清爽
      Toast.loading({ forbidClick: true, duration: 0, className: 'apple-toast-loading' });

      // 4. 请求新的 token 和 userInfo
      await this.changeUSER(selectedSchool.schoolCode);
      
      Toast.clear();
      Notify({ type: 'success', message: '身份已成功切换', duration: 1500 });
    },

    // 1.5 根据新的 schoolCode 重新登录获取权限
    async changeUSER(schoolCode) {
      try {
        const res = await loginByOpenId({
          openId: getLocal('openId'),
          schoolCode: schoolCode
        });
        
        if (res.data.obj !== "personBindErrorCode" && res.data.body) {
          // 更新本地 token 和 userInfo，确保接下来的操作 (修改密码/解绑) 在正确的身份下进行
          setLocal("userInfo", JSON.stringify(res.data.body));
          setLocal("Authorization", res.data.body.token);
        } else {
          Toast.fail('身份校验失败');
        }
      } catch (error) {
        console.error('切换身份登录失败', error);
        Toast.fail('网络异常，切换失败');
      }
    },

    // ================= 2. 修改密码逻辑 =================
    
    validatePwdLength(val) {
      return val && val.length >= 6;
    },
    validatePwdConfirm(val) {
      return val === this.pwdForm.password;
    },
    onFailed(errorInfo) {
      // 校验失败统一使用苹果风格 Notify
      Notify({ type: 'warning', message: errorInfo.errors[0].message });
    },

    async onSubmitPassword() {
      this.loading = true;
      try {
        await updateTeacherPassword({
          schoolCode: this.currentSchoolCode,
          phoneNumber: this.phoneNumber,
          password: this.pwdForm.password
        });
        
        Notify({ type: 'success', message: '密码修改成功，请重新登录', duration: 2500 });
        this.showPwdPopup = false;
        this.pwdForm.password = '';
        this.pwdForm.confirmPassword = '';
        
        setTimeout(() => {
          this.doLogout();
        }, 2000);
      } catch (error) {
        Notify({ type: 'danger', message: error.message || '密码修改失败' });
      } finally {
        this.loading = false;
      }
    },

    // ================= 3. 解绑当前账号逻辑 =================
    
    handleUnbind() {
      if (!this.currentSchoolCode || !this.phoneNumber) {
        Toast('无法获取账号信息');
        return;
      }

      // Dialog 重构为苹果标准风格 (在 style 中通过全局类名覆盖)
      Dialog.confirm({
        title: '确认账号解绑',
        message: `您确定要注销并解绑在【${this.currentSchoolName}】的教师身份吗？\n(账号：${this.phoneNumber})`,
        confirmButtonText: '解绑注销',
        cancelButtonText: '取消',
        className: 'apple-dialog' // 增加类名以便覆盖样式
      }).then(async () => {
        try {
          Toast.loading({ forbidClick: true, duration: 0 });
          
          await unbindTeacherAccount({
            schoolCode: this.currentSchoolCode,
            phoneNumber: this.phoneNumber
          });
          
          Toast.clear();
          Notify({ type: 'success', message: '账号已安全解绑', duration: 2000 });
          
          // 解绑成功后清理本地缓存并退出登录
          setTimeout(() => {
            this.doLogout();
          }, 1500);
          
        } catch (error) {
          Toast.clear();
          Toast.fail(error.message || '解绑失败');
        }
      }).catch(() => {});
    },

    // 4. 统一的退出登录清理逻辑
    doLogout() {
      removeLocal('userInfo');
      removeLocal('Authorization');
      // 如果需要把 openId 也清掉取消自动登录： removeLocal('openId');
      sessionStorage.removeItem('teacherTitleInfo');
      
      // 增加平滑跳转
      setTimeout(() => {
        this.$router.replace('/login'); 
      }, 300);
    }
  }
};
</script>

<style lang="less" scoped>
/* ========== 全局重置与字体 (仿苹果) ========== */
.apple-style {
  width: 100%;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
  background-color: #fbfbfd; /* 苹果官网底色 */
  /* 使用系统字体栈 */
  font-family: -apple-system, BlinkMacSystemFont, "SF Pro Text", "PingFang SC", "Helvetica Neue", Arial, sans-serif;
  -webkit-font-smoothing: antialiased; /*字体抗锯齿*/
  color: #1d1d1f;
}

/* ========== 1. 沉浸式动态磨玻璃背景 ========== */
.ambient-background {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 0;
  pointer-events: none; /* 不处理事件 */
}

/* 莫兰迪壁纸色系 */
.orb {
  position: absolute;
  border-radius: 50%;
  filter: blur(80px);
  opacity: 0.35;
}

.orb-1 {
  width: 80vw;
  height: 80vw;
  background: #a2d2ff;
  top: -20%;
  left: -20%;
  animation: breathe 15s infinite ease-in-out;
}

.orb-2 {
  width: 70vw;
  height: 70vw;
  background: #ffafcc;
  bottom: 10%;
  right: -10%;
  animation: breathe 18s infinite ease-in-out reverse;
}

.orb-3 {
  width: 50vw;
  height: 50vw;
  background: #cdb4db;
  top: 40%;
  left: 30%;
  animation: rotate 25s infinite linear;
}

/* 细微噪点遮罩，增加质感 */
.noise-overlay {
  position: absolute;
  top: 0; left: 0; width: 100%; height: 100%;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='noiseFilter'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.65' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23noiseFilter)' opacity='0.02'/%3E%3C/svg%3E");
}

@keyframes breathe {
  0%, 100% { transform: scale(1) translate(0, 0); }
  50% { transform: scale(1.1) translate(20px, -20px); }
}
@keyframes rotate {
  to { transform: rotate(360deg); }
}

/* ========== 核心磨玻璃样式定义 ========== */
.glass-surface {
  background: rgba(255, 255, 255, 0.4); /* 半透明白 */
  backdrop-filter: blur(20px) saturate(180%); /* 核心模糊与饱和度提升 */
  -webkit-backdrop-filter: blur(20px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.3); /* 极细的白色高光边框 */
  box-shadow: 0 8px 32px 0 rgba(0, 0, 0, 0.04); /* 柔和阴影 */
}

/* ========== 2. 内容布局 ========== */
.main-content {
  position: relative;
  z-index: 1;
  padding: 24px 16px 40px;
  max-width: 600px;
  margin: 0 auto;
}

/* ========== 头部信息卡片重构 ========== */
.profile-card {
  border-radius: 24px;
  padding: 24px;
  position: relative;
  overflow: hidden;
  margin-bottom: 20px;
  transition: transform 0.2s ease;
  
  &:active {
    transform: scale(0.99); /* 点击微缩反馈 */
  }

  .card-body {
    display: flex;
    align-items: center;
  }

  .avatar-wrap {
    width: 68px;
    height: 68px;
    background: rgba(255, 255, 255, 0.8);
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 18px;
    
    .avatar-icon {
      font-size: 36px;
      color: #1d1d1f; /* 深黑图标 */
    }
  }

  .info-wrap {
    flex: 1;
    
    .name {
      font-size: 22px;
      font-weight: 700;
      letter-spacing: -0.5px;
      margin-bottom: 4px;
    }
    
    .phone {
      font-size: 15px;
      color: #1d1d1f;
      opacity: 0.8;
      font-family: Arial, sans-serif; /* 数字使用 Arial */
      margin-bottom: 8px;
    }

    .school-tag {
      display: inline-flex;
      align-items: center;
      gap: 4px;
      padding: 4px 10px;
      background: rgba(0, 0, 0, 0.05); /* 极淡的底色 */
      border-radius: 10px;
      font-size: 13px;
      color: #515154;
    }
  }
}

/* 悬浮药丸切换按钮 */
.switch-pill-btn {
  position: absolute;
  top: 16px;
  right: 16px;
  background: rgba(0, 0, 0, 0.04);
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  border: none;
  padding: 6px 14px;
  border-radius: 100px; /* 药丸形状 */
  font-size: 13px;
  font-weight: 500;
  color: #1d1d1f;
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
  border: 0.5px solid rgba(0,0,0,0.03);
  transition: all 0.2s ease;
  
  &:active {
    background: rgba(0, 0, 0, 0.1);
  }
}

/* ========== 操作菜单区域重构 ========== */
.menu-section {
  border-radius: 20px;
  overflow: hidden; /* 切割圆角 */
  margin-bottom: 24px;
  padding: 4px 0; /* 上下留白，让 Cell 居中 */
}

/* 定制 Vant Cell，使其变透明和 iOS 风格 */
.transparent-group {
  background: transparent !important;
}

.apple-cell {
  background: transparent !important;
  padding: 16px 20px !important;
  align-items: center;
  
  /* 调整标题 */
  ::v-deep .van-cell__title {
    font-size: 17px;
    font-weight: 600;
    color: #1d1d1f;
  }
  
  /* 调整左侧图标 */
  ::v-deep .van-cell__left-icon {
    font-size: 20px;
    color: #515154; /* 深灰图标 */
    margin-right: 14px;
  }
  
  /* 调整右侧箭头 */
  ::v-deep .van-cell__right-icon {
    font-size: 16px;
    color: #3c3c434d; /* iOS 标准灰色箭头 */
  }

  /* 调整右侧 Value 字样 ("去切换") */
  ::v-deep .van-cell__value {
    font-size: 15px;
    color: #86868b; /* 苹果标准灰色文本 */
  }

  /* 自定义 iOS 分割线 */
  &::after {
    left: 54px !important; /* 图标文字对齐 */
    border-color: rgba(60, 60, 67, 0.12) !important; /* iOS 极淡分割线 */
  }
  
  &:last-child::after {
    display: none;
  }
  
  /* 点击态 */
  &:active {
    background-color: rgba(0, 0, 0, 0.05) !important;
  }
}

/* 红色警示 Cell */
.danger-cell {
  ::v-deep .van-cell__title, 
  ::v-deep .van-cell__left-icon {
    color: #ff3b30 !important; /* 苹果红 */
  }
}

.security-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 12px;
  color: #86868b;
  margin-top: 10px;
}

/* ========== ===================== ==================== ========== */
/* ========== 弹窗组件通用重写 (Apple Glass) ========== */




/* Vant Field 定制为 iOS 设置列表风格 */
.pwd-form {
  padding-bottom: 20px;
}

.ios-list-group {
  margin: 0 16px;
  margin-top: 16px;
  border-radius: 14px;
  overflow: hidden;
  background: rgba(0, 0, 0, 0.03); /* 灰色输入框背景 */
}

.ios-field {
  padding: 14px 16px !important;
  background: transparent !important;
  
  &::after {
    left: 16px !important;
    border-color: rgba(60, 60, 67, 0.12) !important;
  }
  
  ::v-deep .van-field__label {
    width: 70px;
    font-size: 16px;
    font-weight: 500;
    color: #000;
  }
  
  ::v-deep .van-field__control {
    font-size: 16px;
    font-family: Arial, sans-serif;
    &::placeholder {
      color: #3c3c434d;
    }
  }
}

.submit-btn-wrap {
  margin: 32px 16px 10px;
}

/* 苹果标准纯黑按钮，极大提升质感 */
.apple-btn-primary {
  height: 52px;
  background: #000 !important; /* 高对比度黑 */
  color: #fff !important;
  border: none !important;
  border-radius: 14px !important; /* iOS 15+ 风格大圆角 */
  font-size: 17px;
  font-weight: 600;
  letter-spacing: -0.4px;
  transition: all 0.2s ease;
  
  &:active {
    opacity: 0.8;
    transform: scale(0.98);
  }
}

/* Picker 定制为 iOS 滚轮风格 */
.apple-picker {
  background: transparent !important;
  
  ::v-deep .van-picker__toolbar {
    background: transparent;
    height: 50px;
    border-bottom: 0.5px solid rgba(60, 60, 67, 0.1);
    
    button {
      font-size: 16px;
      font-weight: 400;
      color: #007aff !important; /* 苹果蓝 */
    }
    
    .van-picker__title {
      font-weight: 600;
      font-size: 17px;
    }
  }
  
  /* 滚轮样式调整 */
  ::v-deep .van-picker-column__item {
    font-size: 18px;
    color: #1d1d1f;
  }
}

/* ========== 通用组件覆盖 (Dialog/Toast) ========== */
/* 这里需要在 App.vue 或全局样式文件中引入，才能覆盖组件内部样式 */
/* 如果在这里加 ::v-deep 可能对 Dialog 不起作用，请确保全局引入类名对应的样式 */
</style>

